/*jshint esversion: 6 */
import React, { useState } from 'react';
import axios from "axios";
import gs from "../../Singleton";
import {url_api_gender} from "../ApiUrls";


function HumanCreateGenderModal(props){
    "use strict";

    const [newGender, setNewGender] = useState('');
    const [newDescription, setNewDescription] = useState('');
    const [newGoodAdd, setNewGoodAdd] = useState(false);
    const [newError, setNewError] = useState(null);

    function createNewElementGood(response){
        if (response.status === 201) {
            setNewGoodAdd(true);
            props.update('gender');
        } else{
            setNewGoodAdd(false);
        }
    }

    const submitAddNewGender = e => {
        setNewGoodAdd(false);
        axios({
            method: "POST",
            url: url_api_gender,
            responseType: 'json',
            contentType: 'application/json',
            data: {
                title: newGender,
                description: newDescription,
            }
            })
            .then(response => {
                setNewError(null);
                setNewGender("");
                setNewDescription("");
                createNewElementGood(response);
            })
            .catch(function (error) {
                setNewError(error);
            });
    };

    function clear_messages(){
        setNewError(null);
        setNewGoodAdd(false);
    }

    function ModalHeader(){
        return (
            <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                onClick={clear_messages}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        )
    };

    function ModalFooter(){
        return (
            <div>
                <div className="modal-footer">
                    <input type="button" className="button button_blue" form="gender_add"
                           value="Add" onClick={submitAddNewGender} />
                    <button type="button" className="button button_white" data-dismiss="modal"
                    onClick={clear_messages} >Close
                    </button>
                </div>
                {newError
                    ? newError.response.data.title ? newError.response.data.title[0] : ""
                : ""}
                {newGoodAdd?"Element Add!!":""}
            </div>
        )
    };

    return (
        <div className="modal fade" id="Modal_gender" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel"
             aria-hidden="true">
        {/*<!-----------------------------------Modal-------------------->*/}
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    {ModalHeader()}
                    <div className="modal-body">
                        <h2 className="modal-title" id="myModalLabel">Add gender</h2>
                        <form id="gender_add">
                            <input className="profile__input" type="text" placeholder="Input gender" name="name"
                                   form="gender_add"
                                   value={newGender?newGender:''}
                                   onChange={t => setNewGender(t.target.value)}/>
                            <input className="profile__input" type="text" placeholder="Input description"  name="name"
                                   form="gender_add"
                                   value={newDescription?newDescription:''}
                                   onChange={t => setNewDescription(t.target.value)} />
                        </form>
                    </div>
                    {ModalFooter()}
                </div>
            </div>
        </div>
    )
}

export default HumanCreateGenderModal;
